module.exports = __webpack_public_path__ + "static/media/logo.edfaa829.png";